import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, X, Compass, Flame, Aperture, Gamepad2 } from 'lucide-react';
import { QUIZZES } from '../data/quizzes';
import { QuizRunner } from '../components/QuizRunner';
import { wellnessOptions } from '../api';

const ICONS = { clair: Sparkles, witch: Compass, chakra: Aperture, element: Flame };

const Discover = () => {
  const [active, setActive] = useState(null);
  const [meta, setMeta] = useState([]);

  useEffect(() => { wellnessOptions().then((d) => setMeta(d.quizzes || [])).catch(() => {}); window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-[#0a0708] pt-28 pb-24 px-4" data-testid="discover-page">
      <div className="max-w-5xl mx-auto text-center mb-14">
        <p className="font-jost text-[11px] uppercase tracking-[0.4em] text-[#f0d582]/70">Prestige Discoveries</p>
        <h1 className="font-cinzel text-4xl sm:text-5xl text-gold-gradient mt-3">Discover Your Path</h1>
        <p className="font-cormorant text-xl text-[#f5ecd9]/70 max-w-2xl mx-auto mt-4">Playful, insightful discovery tools that help shape your Prestige Wellness Profile. Take one now — no account needed — and save your results to personalize your experience.</p>
      </div>

      <div className="max-w-4xl mx-auto grid sm:grid-cols-2 gap-6">
        {Object.values(QUIZZES).map((q) => {
          const Icon = ICONS[q.key] || Sparkles;
          return (
            <button key={q.key} data-testid={`discover-card-${q.key}`} onClick={() => setActive(q)} className="text-left card-glass rounded-2xl p-7 border border-white/8 hover:border-[#d4af37]/40 transition-all group">
              <div className="h-12 w-12 rounded-full bg-[#d4af37]/10 flex items-center justify-center mb-4 group-hover:bg-[#d4af37]/20 transition-colors"><Icon className="h-6 w-6 text-[#f0d582]" /></div>
              <h3 className="font-cinzel text-2xl text-[#f5ecd9]">{q.title}</h3>
              <p className="font-cormorant text-lg text-[#f5ecd9]/65 mt-2">{q.tagline}</p>
              <span className="inline-block mt-4 font-jost text-xs uppercase tracking-widest text-[#f0d582]">Begin discovery →</span>
            </button>
          );
        })}
      </div>

      <p className="text-center font-jost text-xs text-[#f5ecd9]/40 mt-10 max-w-xl mx-auto">These are reflective discovery tools for self-exploration, not diagnoses. Your profile grows and changes as you do — retake anytime.</p>

      <div className="max-w-3xl mx-auto mt-12">
        <Link to="/sacred-aiko" data-testid="discover-sacred-aiko" className="flex items-center gap-4 card-glass rounded-2xl p-6 border border-[#ff4da6]/20 hover:border-[#ff4da6]/50 transition-all">
          <div className="h-12 w-12 rounded-full bg-[#ff4da6]/10 flex items-center justify-center shrink-0"><Gamepad2 className="h-6 w-6 text-[#ff4da6]" /></div>
          <div className="min-w-0"><h3 className="font-cinzel text-xl text-[#f5ecd9]">Enter Sacred Aiko</h3><p className="font-cormorant text-[#f5ecd9]/60">Step into our sister experience — an interactive world woven from the same elemental energy.</p></div>
          <span className="ml-auto text-[#ff4da6] shrink-0">→</span>
        </Link>
      </div>

      {active && (
        <div className="fixed inset-0 z-[60] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4" onClick={() => setActive(null)}>
          <div className="relative bg-[#12100f] border border-[#d4af37]/25 rounded-2xl p-6 sm:p-9 max-w-lg w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <button data-testid="quiz-close" onClick={() => setActive(null)} className="absolute top-4 right-4 text-[#f5ecd9]/50 hover:text-[#f5ecd9]"><X className="h-5 w-5" /></button>
            <QuizRunner quiz={active} onClose={() => setActive(null)} />
          </div>
        </div>
      )}
    </div>
  );
};

export default Discover;
